import { api } from 'utility';
import {
  getCreateFunderUrl,
  getEditFunderUrl,
  getAddressExportFileUrl,
  getGetAllWalletAndGuildUrl,
  getExportAllWalletAndGuildUrl,
  getSummaryFunderUrl,
  getReportFunderUrl,
  getReportFunderTransactionUrl,
  getGetUploadedMediaFromOwnerBranchUrl,
  getGetTagListsUrl,
} from 'URLs';
class Serivces {
  /**
   * ایجاد تنخواه دار
   */
  addFunder(data) {
    return api.post(getCreateFunderUrl(), data).then((res) => res.data);
  }
  /**
   * ویرایش تنخواه دار
   */
  editFunder(data, personId) {
    return api.put(getEditFunderUrl(personId), data).then((res) => res.data);
  }
  /**
   * لیست تنخواه دار
   */
  getFunders(params) {
    return api.get(getCreateFunderUrl(), { params }).then((res) => res.data);
  }

  /**
   * لیست صورت حساب تنخواه دار
   */
  getFunderTransactions(params, userId) {
    return api.get(getReportFunderTransactionUrl(userId), { params });
  }
  /**
   * مشاهده مدارک آپلود شده تنخوا دار توسط مالک
   */
  getMetaData(thingUserId, params) {
    return api
      .get(getGetUploadedMediaFromOwnerBranchUrl(thingUserId), { params })
      .then((res) => res.data);
  }

  /**
   * لیست برچسب ها
   */
  getListTag(thingUserId, params) {
    return api.get(getGetTagListsUrl(thingUserId), { params }).then((res) => res.data);
  }

  getReportFunder(data, params) {
    return api.post(getReportFunderUrl(), data, { params }).then((res) => res.data);
  }

  getSummaryReportFunder(userId, data, params) {
    return api.post(getSummaryFunderUrl(userId), data, { params }).then((res) => res.data);
  }
  getAllwalletAndGuild(data, params) {
    return api.post(getGetAllWalletAndGuildUrl(), data, { params }).then((res) => res.data);
  }
  getAddressExportFile() {
    return api.get(getAddressExportFileUrl()).then((res) => res.data);
  }
  reportPdfWalletAndGuild(data, params) {
    return api.post(getExportAllWalletAndGuildUrl(), data, { params }).then((res) => res.data);
  }
}

export default new Serivces();
